import * as React from "react";
import { createPortal } from "react-dom";
import { twMerge } from "tailwind-merge";
import { SVGs } from "../assets";
import { useSnackBar } from "../stores";
import Text from "./Text";

function classesByType(type: "success" | "error" | "warning") {
  switch (type) {
    case "error":
      return {
        bar: "bg-red-500",
        surface: "bg-red-500/10",
      };
    case "warning":
      return {
        bar: "bg-amber-500",
        surface: "bg-amber-500/10",
      };
    default:
      return {
        bar: "bg-emerald-500",
        surface: "bg-emerald-500/10",
      };
  }
}

export default function Snackbar() {
  const { open, message, type, duration, closeSnackbar } = useSnackBar();

  React.useEffect(() => {
    if (!open) return;
    if (!duration || duration <= 0) return;
    const t = window.setTimeout(() => closeSnackbar(), duration);
    return () => window.clearTimeout(t);
  }, [open, duration, closeSnackbar]);
  const colors = classesByType(type);

  return createPortal(
    <div className="fixed right-[16px] top-[16px] z-[9999] pointer-events-none">
      <div
        className={twMerge(
          "pointer-events-auto min-h-[50px] w-[360px] max-w-[calc(100vw-32px)] overflow-hidden bg-surface",
          "transition-[transform,opacity] duration-200 ease-out",
          open ? "opacity-100 translate-x-0" : "opacity-0 translate-x-4",
          open ? "pointer-events-auto" : "pointer-events-none",
        )}
        role="status"
        aria-live="polite"
        aria-hidden={!open}
      >
        <div className={twMerge("flex items-center", colors.surface)}>
          <div className={twMerge("self-stretch w-[8px]", colors.bar)} />
          <div className="flex flex-1 items-center justify-between px-[10px] py-[10px]">
            <Text className={twMerge("break-words font-[500]")}>{message}</Text>
            <button
              type="button"
              aria-label="Close snackbar"
              className="shrink-0 rounded-[8px] p-[6px] hover:bg-background/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30"
              onClick={() => closeSnackbar()}
            >
              <img src={SVGs.close} alt="Close" className="h-[14px] w-[14px]" />
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
}
